export const wpClassNames = {
    INFOBOX_WRAPPER: 'cdm-infobox-wrapper',
    INFOBOX: 'cdm-infobox',
    INFOBOX_CONTAINER: 'infobox-Container',
    INFOBOX_TITLE: 'cdm-infobox-title',
    INFOBOX_ICON: 'hideIcon'
}